import React, { useCallback } from 'react';

export type UserSuggestedEmailModalContextType = {
  visible: boolean;
  openModal: () => void;
  closeModal: () => void;
};

const UserSuggestedEmailModalContext =
  React.createContext<UserSuggestedEmailModalContextType>(null);

export const UserSuggestedEmailModalContextProvider: React.FC = ({
  children,
}) => {
  const [visible, setVisible] = React.useState(false);

  const openModal: UserSuggestedEmailModalContextType['openModal'] =
    useCallback(() => {
      setVisible(true);
    }, []);

  const closeModal: UserSuggestedEmailModalContextType['closeModal'] =
    useCallback(() => {
      setVisible(false);
    }, []);

  return (
    <UserSuggestedEmailModalContext.Provider
      value={{
        visible,
        openModal,
        closeModal,
      }}
    >
      {children}
    </UserSuggestedEmailModalContext.Provider>
  );
};

export default UserSuggestedEmailModalContext;
